import { render } from "./ModalZonal.vue?vue&type=template&id=5f488966&scoped=true"
import script from "./ModalZonal.vue?vue&type=script&lang=js"
export * from "./ModalZonal.vue?vue&type=script&lang=js"

import "./ModalZonal.vue?vue&type=style&index=0&id=5f488966&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f488966"]])

export default __exports__